import { ProjectParticipation } from './project-participation.enum.model';

export class ProjectFilters {
    page: number;

    isMyOrganizationChecked: boolean;
    organizationId: string;

    isAllMyCommunitiesChecked: boolean;
    communitiesIds: string[];

    isMySkillsChecked: boolean;
    skillsIds: string[];

    isMyOrganizationSkillsChecked: boolean;
    organizationSkillsIds: string[];

    isMyInterestsChecked: boolean;
    interestsIds: string[];

    isAllCommunitiesChecked: boolean;

    projectParticipation: ProjectParticipation;
    projectTypesIds: string[];

    search: string;
    
}
